export default {
  init() {
    const body = $('body');

    // Nav Menu Mobile
    const navMenuMobileModal = $('.nav-menu-mobile-modal');
    if (navMenuMobileModal.length) {
      $(document).on('click', '.nav-menu-mobile-modal-trigger', function (e) {
        e.preventDefault();

        body.addClass('left-side-open mobile-menu-open');
      });

      $(document).on('click', '.nav-menu-mobile-modal-close', function (e) {
        e.preventDefault();

        body.removeClass('left-side-open');
      });
    }

    // Hotel Booking Modal
    const hotelBookingModal = $('.hotel-booking-modal');
    if (hotelBookingModal.length) {
      $(document).on('click', '.hotel-booking-modal-trigger', function (e) {
        e.preventDefault();

        body.addClass('right-side-open');
      });

      $(document).on('click', '.hotel-booking-modal-close', function (e) {
        e.preventDefault();

        body.removeClass('right-side-open');
      });

      $(document).on('click', '.book-form-trigger', function (e) {
        e.preventDefault();

        body.addClass('right-side-open');
        hotelBookingModal.find('#menu-booking-room-tab').trigger('click');
      });

      $(document).on('click', '.enquire-form-trigger', function (e) {
        e.preventDefault();

        body.addClass('right-side-open');
        hotelBookingModal.find('#menu-booking-venue-tab').trigger('click');

        const venueEnquiryTab = hotelBookingModal.find('#menu-booking-venue-enquiry-tab');
        if (venueEnquiryTab.length) {
          venueEnquiryTab.trigger('click');
        }
      });

      $(document).on('click', '.enquire-weddings-form-trigger', function (e) {
        e.preventDefault();

        body.addClass('right-side-open');
        hotelBookingModal.find('#menu-booking-venue-tab').trigger('click');

        const venueWeddingsEnquiryTab = hotelBookingModal.find('#menu-booking-venue-weddings-enquiry-tab');
        if (venueWeddingsEnquiryTab.length) {
          venueWeddingsEnquiryTab.trigger('click');
        }
      });

      $('.overlay-close').on('click', function() {
        body.removeClass('right-side-open');
      });

      $(document).ready(function() {
        if (window.location.hash === '#enquire-form-trigger') {
          body.addClass('right-side-open');
          hotelBookingModal.find('#menu-booking-venue-tab').trigger('click');

          const venueEnquiryTab = hotelBookingModal.find('#menu-booking-venue-enquiry-tab');
          if (venueEnquiryTab.length) {
            venueEnquiryTab.trigger('click');
          }
        }
      });
    }
  },
  finalize() {},
};



// WEBPACK FOOTER //
// ./scripts/routes/components/modals.js